module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('em', [_vm._v("Paris Under Water")])]), _vm._v(" "), _c('p', {
    staticClass: "fpage"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "OEBPS/images/f00ii-01.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig2"
    }
  }), _c('em', [_vm._v("Map of the flooded area in January–February 1910")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fpage"
  }), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "ttl"
    }
  }), _c('em', [_vm._v("Paris Under Water")])]), _vm._v(" "), _c('p', {
    staticClass: "stitle"
  }, [_vm._v("HOW "), _c('em', [_vm._v("the")]), _vm._v(" CITY "), _c('em', [_vm._v("of")]), _vm._v("  LIGHT"), _c('br'), _vm._v("SURVIVED "), _c('em', [_vm._v("the")]), _c('br'), _vm._v("GREAT FLOOD"), _c('br'), _c('em', [_vm._v("of")]), _vm._v(" 1910")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("JEFFREY H. JACKSON")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "OEBPS/images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0209eeaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780230617063_01_tit.vue
// module id = 60
// module chunks = 0